/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type { ArcoDto, GetTrasferimentiParams } from ".././models";

export const getTrasferimenti = (
  portale: 1 | 2 | 3,
  params?: GetTrasferimentiParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ArcoDto[]>> => {
  return axios.get(`/api/portali/${portale}/trasferimenti`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetTrasferimentiQueryKey = (
  portale: 1 | 2 | 3,
  params?: GetTrasferimentiParams
) =>
  [
    `/api/portali/${portale}/trasferimenti`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTrasferimentiQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrasferimenti>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetTrasferimentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrasferimenti>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getTrasferimenti>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTrasferimentiQueryKey(portale, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrasferimenti>>
  > = ({ signal }) =>
    getTrasferimenti(portale, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!portale, ...queryOptions };
};

export type GetTrasferimentiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrasferimenti>>
>;
export type GetTrasferimentiQueryError = AxiosError<unknown>;

export const useGetTrasferimenti = <
  TData = Awaited<ReturnType<typeof getTrasferimenti>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  params?: GetTrasferimentiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrasferimenti>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTrasferimentiQueryOptions(
    portale,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetTrasferimenti = () =>
  //@ts-ignore
  useGetTrasferimenti(...([] as any[]));
